import apiClient from './apiClient';

const apiBaseURL = '/use-cases';

export interface Comment {
  id: string;
  use_case_id: string;
  // Ajoutez d'autres champs selon vos types
}

export const commentService = {
  /**
   * Récupère les commentaires associés à un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   */
  async listByUseCase(useCaseId: string): Promise<Comment[]> {
    const response = await apiClient.get<Comment[]>(`${apiBaseURL}/${useCaseId}/comments/`);
    return response.data;
  },

  /**
   * Crée un nouveau commentaire pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @param data - Les données du commentaire
   */
  async create(useCaseId: string, data: any): Promise<Comment> {
    const response = await apiClient.post<Comment>(`${apiBaseURL}/${useCaseId}/comments/`, data);
    return response.data;
  },

  /**
   * Met à jour un commentaire existant
   * @param useCaseId - L'ID du cas d'usage
   * @param commentId - L'ID du commentaire
   * @param data - Les données de mise à jour
   */
  async update(useCaseId: string, commentId: string, data: any): Promise<Comment> {
    const response = await apiClient.put<Comment>(`${apiBaseURL}/${useCaseId}/comments/${commentId}`, data);
    return response.data;
  },

  /**
   * Supprime un commentaire
   * @param useCaseId - L'ID du cas d'usage
   * @param commentId - L'ID du commentaire
   */
  async delete(useCaseId: string, commentId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}/${useCaseId}/comments/${commentId}`);
  }
};

export default commentService;
